import Axios from "axios";
import { CMError } from "./cm-error.model";
import Vue from 'vue'

Vue.mixin( {
  beforeCreate() {
    const options = this.$options;
    if ( options.MulinoAPI )
      this.$mulinoApi = options.MulinoAPI;
    else if ( options.parent && options.parent.$mulinoApi )
      this.$mulinoApi = options.parent.$mulinoApi;
  }
} );

export function makeMulinoAPI(token, conf) {
    return new MulinoAPI(token, conf);
}

export class MulinoAPI {

    constructor(token, conf) {
        this.__ax = null;
        this._conf = conf;
        this._token = token;
    }

    get _ax() {
        if(this.__ax === null) {
            this.__ax = Axios.create({
                baseURL: this._conf.getters.conf.mulino_url,
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": "Bearer " + this._token,
                }
            });
        }
        return this.__ax;
    }

    async getTopics(filter) {
        try {
            const res = await this._ax.get('/topics/search/' + encodeURIComponent(filter));
            return res.data.map((t) => {
                return { id: t.idtopic, name: t.name };
            });
        } catch (error) {
            this._handleError(error);
        }
    }

    _handleError(error) {
        if (error.response) {
            if (error.response.status === 401) {
                console.error(error.response.data.errors[0].message);
                throw new CMError('UnauthorizedRedirect', error.response.data.errors[0].message);
            }
            if (this._checkTokenDelete(error.response.data.errors)) {
                console.error('Invalid or expired token');
                throw new CMError('Unauthorized', 'Invalid or expired token');
            }
            const errMess = error.response.data.errors.reduce((errT, err) => {
                return errT += `[${err.name}] => ${err.message};`;
            }, '');
            console.error(errMess);
            throw new CMError('CMServerErrorList', errMess);
        } else if (error.request) {
            console.error('Error on request => Server does not respond');
            throw new Error('Error on request => Server does not respond');
        } else {
            console.error('Client error => ' + error.message);
            throw new Error('Client error => ' + error.message);
        }
    }

    _checkTokenDelete(errors) {
        if (!errors) { return false; }
        const tError = errors.findIndex((elem) => {
            return elem.name === 'CMInvalidTokenError' || elem.name === 'CMInvalidExpiredError';
        });
        return tError !== -1;
    }

}